const text = `
# Project Outputs

Here we will include information on the project outputs, including software, documents and the validation data set.
`;

export default text;
